@let label = labelSg();
@let pendingFiles = pendingFilesSg();
@let existingFileNames = existingFileNamesSg();

<div class="atn-files-input">
  @if (label) {
    <b>{{ label }}</b>
  }

  <atn-ds-file (fileChange)="addFileHandler($event)" />

  @if (existingFileNames.length > 0) {
    <ul class="atn-files-input__list">
      @for (name of existingFileNames; track name) {
        @let fileKey = perFileKey(name);
        @if (fileKey) {
          @let isDownloading =
            kbFeature.selectors.isDownloading(fileKey).asSignal();
          @let downloadUrl =
            kbFeature.selectors.downloadUrl(fileKey).asSignal();
          @let isDeleting = kbFeature.selectors.isDeleting(fileKey).asSignal();
          <li class="atn-files-input__item">
            <span class="atn-files-input__item-name">{{ name }}</span>
            @if (downloadUrl) {
              <a
                [href]="downloadUrl"
                target="_blank"
                rel="noopener"
                >Download</a
              >
            } @else {
              <atn-ds-button
                [isIcon]="true"
                [loading]="isDownloading"
                (click)="downloadClickHandler(name)"
              >
                <i class="atn-icon atn-download"></i>
              </atn-ds-button>
            }
            <atn-ds-button
              [isIcon]="true"
              [loading]="isDeleting"
              (click)="deleteClickHandler(name)"
            >
              <i class="atn-icon atn-trash atn-red"></i>
            </atn-ds-button>
          </li>
        }
      }
    </ul>
  }

  @if (pendingFiles.length > 0) {
    <ul class="atn-files-input__list atn-files-input__list--pending">
      @for (file of pendingFiles; track file) {
        <li class="atn-files-input__item">
          <span class="atn-files-input__item-name">{{ file.name }}</span>
          <atn-ds-button
            [isIcon]="true"
            (click)="removePendingFileHandler(file)"
          >
            <i class="atn-icon atn-trash atn-red"></i>
          </atn-ds-button>
        </li>
      }
    </ul>
  }
</div>
